export const normalizeRole = (value: string) =>
  value.replace(/\s+/g, '').toLowerCase();